export default __webpack_public_path__ + "static/media/carousel-placeholder.e95b08fa.webp";